import React from 'react';
import { Button } from '@wix/wix-base-ui';
import type { IMenuItem } from '#packages/baseUI';
import type { MenuItem as DSMenuItem } from 'types/documentServices';
import { translate } from '#packages/i18n';
import { TRANSLATIONS_MAP } from './translations';
import _ from 'lodash';
export const SLOT_PREFIX = 'SLOT';

export const createSlotItem = (
  parentItem: DSMenuItem,
  edit?: (item: DSMenuItem) => void,
): IMenuItem => ({
  type: 'BasicMenuItem',
  id: `${parentItem.id}__${SLOT_PREFIX}`,
  label: translate(TRANSLATIONS_MAP.ITEM.CONTAINER.label),
  isVisible: true,
  isVisibleMobile: false,
  symbol: 'containerPageType',
  customButton: (
    <Button
      className="btn-confirm-secondary btn-sm menu-manage-panel__slot-custom-button"
      onClick={() => edit?.(parentItem)}
    >
      {translate(TRANSLATIONS_MAP.ITEM.CONTAINER.edit)}
    </Button>
  ),
  items: [],
  blockDragAndDrop: true,
});

export const removeSlotItem = (item: DSMenuItem) =>
  item.slot ? { ...item, items: [] } : item;

export const isSlotItem = (item: DSMenuItem) => item.id.endsWith(SLOT_PREFIX);

export const isSlotContainer = (item: Partial<DSMenuItem>) =>
  _.has(item, 'slot');
